var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo40Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54971 20C6.54971 12.5716 12.5716 6.54971 20 6.54971V0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20H33.4503C33.4503 27.4284 27.4284 33.4503 20 33.4503C12.5716 33.4503 6.54971 27.4284 6.54971 20Z",
    fill: "#523063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.92 20C27.92 21.5664 27.4555 23.0977 26.5852 24.4001C25.7149 25.7025 24.478 26.7177 23.0308 27.3171C21.5836 27.9166 19.9912 28.0734 18.4548 27.7678C16.9185 27.4622 15.5073 26.7079 14.3997 25.6003C13.292 24.4926 12.5377 23.0814 12.2321 21.5451C11.9265 20.0088 12.0834 18.4163 12.6828 16.9691C13.2823 15.5219 14.2974 14.285 15.5998 13.4147C16.9023 12.5445 18.4335 12.08 20 12.08L20 20L27.92 20Z",
    fill: "#523063"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo40Svg);
export default __webpack_public_path__ + "static/media/logo40svg.eb7ee8de8ebf7899060a5f1232855b45.svg";
export { ForwardRef as ReactComponent };